import BaseCommand from "@/models/api/commands/BaseCommand";

export class RemoveBookingItemCommand extends BaseCommand {
  CommandName = "RemoveBookingItem";
  Command: { BookingItemTmpId: string };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId };
  }
}
